import { h, Component } from 'preact';
import style from './style';

export default class Controls extends Component {
  selector = (mode) => {
    this.props.modeSelector(mode);
  };
  render(props, state) {
    const { availableModes } = props;
    return (
      <div class={'controls'}>
        <div class={'wootag-logo'} />
        <ul>
          {availableModes.includes(1) && availableModes.length > 1 && (
            <li
              class={`mode1 ${props.mode === 1 ? 'active' : ''}`}
              onClick={this.selector.bind(this, 1)}
            >
              {'Desktop'}
            </li>
          )}
          {availableModes.includes(2) && availableModes.length > 1 && (
            <li
              class={`mode2 ${props.mode === 2 ? 'active' : ''}`}
              onClick={this.selector.bind(this, 2)}
            >
              {'Mobile Interstitial'}
            </li>
          )}
          {availableModes.includes(3) && availableModes.length > 1 && (
            <li
              class={`mode3 ${props.mode === 3 ? 'active' : ''}`}
              onClick={this.selector.bind(this, 3)}
            >
              {'Mobile Embed'}
            </li>
          )}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/controls/index.js